import { trackEvent } from './common/tracking';

export function initConfirmation(toBasketButton: HTMLButtonElement, continueShoppingButton: HTMLButtonElement) {
    toBasketButton?.addEventListener('click', () => {
        trackEvent({
            order_SampleOrderStep: ['redirect_basket'],
            ot_PageCluster: ['SampleOrderFlow']
        });
    });

    continueShoppingButton?.addEventListener('click', () => {
        trackEvent({
            order_SampleOrderStep: ['continue_shopping'],
            ot_PageCluster: ['SampleOrderFlow']
        });
    });
}
